import useGnbCount from '@hooks/useGnbCount';
import React from 'react';
import GnbTabsPresenter from './GnbTabsPresenter';

const GnbTabsContainer: React.FC = () => {
  const { gnbCount } = useGnbCount();

  return <GnbTabsPresenter gnbCount={gnbCount} />;
};

export default GnbTabsContainer;
